var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTel = function SvgTel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.705 12A.704.704 0 0 1 0 11.297V.703C0 .315.316 0 .705 0h6.59C7.685 0 8 .315 8 .703v10.594a.704.704 0 0 1-.705.703H.705Zm3.763-1.172a.471.471 0 0 0-.47-.47.471.471 0 0 0-.47.47.469.469 0 1 0 .94 0ZM1.042 1.407V9.65h6.003V1.407H1.042Z",
    fill: "#666",
    fillRule: "nonzero"
  })));
};

export default SvgTel;